import { ws } from "../../../utils/common";

export const getWaitingShiftWS = async ({ id_association }) => {
    const res = await ws(
        "GET",
        process.env.REACT_APP_ENDPOINT + "user-shift/" + id_association,
        { waiting: true },
        null,
        true
    );

    if (res.error) {
        throw res.data.title;
    } else {
        return res.data;
    }
}

export const confirmSubscriptionShiftWS = async ({ id_user_shift, confirmed }) => {
    const res = await ws(
        "PATCH",
        process.env.REACT_APP_ENDPOINT + "user-shift/confirm/" + id_user_shift,
        null,
        {
            confirmed
        },
        true
    );

    if (res.error) {
        throw res.data;
    } else {
        return res.data;
    }
}